<template>
  <div class="page">
    <div>
      <el-row :gutter="24">
        <el-col :span="12">
          <div v-if="!isHadSetted">
            您还未设置过催记推送信息,是否设置？<el-button type="primary" @click="toPushSetting">立即设置</el-button>
          </div>&nbsp;
        </el-col>
      </el-row>
    </div>
    <div class="m-b-24 bg-content padding15" v-if="isHadSetted">
      <el-form label-width="100px">
        <el-row :gutter="24" class="text left font-medium">
          <span>推送设置</span>
        </el-row>
        <br/>
        <el-row :gutter="24" >
          <el-col :span="18">
            <el-form-item label="推送地址">
              <el-input v-model="pushData.pushUrl" style="width: 50%" placeholder="请输入推送地址,配置地址为空默认清除"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="18">
            <el-form-item label="推送类型">
              <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
              <div style="margin: 15px 0;"></div>
              <el-checkbox-group v-model="pushData.pushTypes" @change="handleCheckedChange">
                <el-checkbox
                  v-for="item in pushTypeOptions"
                  :key="item.value"
                  :label="item.value">{{item.label}}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="推送频率">
              <el-input v-model="pushData.frequency" style="width: 50%"></el-input>
            </el-form-item>
          </el-col>
        </el-row> -->

        <br/>
        <el-col :span="1" :offset="3">
          <div class="text right">
            <el-button type="primary" @click="submit" size="small">保存</el-button>
          </div>
        </el-col>
      </el-form>
    </div>
  </div>
</template>
<script>
const allPushWorkDayValue = ['msg', 'ivr', 'ivoice'];

export default {
  props: [
    'companyIdTemp'
  ],
  data() {
    return {
      isHadSetted: false,
      pushData: {
        id: null,
        companyId: null,
        pushUrl: null,
        pushTypes: ['msg']
      },
      checkAll: false,
      allPushWorkDayValue,
      isIndeterminate: true,
      pushTypeOptions: [
        {
          value: 'msg',
          label: '短信'
        }, {
          value: 'ivr',
          label: '语音'
        }, {
          value: 'ivoice',
          label: '智能语音'
        }
      ]
    };
  },
  watch: {
    companyIdTemp(companyId) {
      this.pushData.companyId = companyId;
      this.getData(companyId);
    }
  },
  mounted() {
  },
  methods: {
    toPushSetting() {
      this.isHadSetted = true;
    },
    handleCheckAllChange(val) {
      this.pushData.pushTypes = val ? this.allPushWorkDayValue : [];
      this.isIndeterminate = false;
    },
    handleCheckedChange(val) {
      const checkedCount = val.length;
      this.checkAll = checkedCount === this.allPushWorkDayValue.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.allPushWorkDayValue.length;
    },
    getData(companyId) {
      this.$ajax({
        url: '/company/getCompanyCollectionRecordPush',
        params: { companyId }
      }).then((res) => {
        console.warn(res);
        if (res.data) {
          this.pushData.id = res.data.id;
          this.pushData.pushUrl = res.data.pushUrl;
          const type = res.data.pushType.split(',');
          this.pushData.pushTypes = type;
          this.isHadSetted = true;
        } else {
          this.pushData.id = null;
          this.pushData.pushUrl = null;
          this.pushData.pushTypes = ['msg'];
          this.isHadSetted = false;
        }
      }).catch((error) => {
        this.$message({
          type: 'error',
          message: error.message
        });
      });
    },
    submit() {
      console.warn(this.pushData);
      if (!this.pushData.id && !this.pushData.pushUrl) {
        this.$message({
          type: 'error',
          message: '请输入推送地址！'
        });
        return;
      }
      if (this.pushData.pushTypes.length === 0) {
        this.$message({
          type: 'error',
          message: '请选择推送类型！'
        });
        return;
      }
      this.$ajax({
        prompt: true,
        url: '/company/saveCompanyCollectionRecordPush',
        data: this.pushData
      }).then((res) => {
        console.warn(res);
      }).catch((error) => {
        this.$message({
          type: 'error',
          message: error.message
        });
      });
    }
  }
};
</script>
<style scoped>
</style>




// WEBPACK FOOTER //
// src/page/main/company/collection_records_push.vue